module.exports = __webpack_public_path__ + "img/demo2.cff368c6.png";